<template>
  <div class="general_frame">
    <div class="pop_general_title">{{ title }}</div>
    <div class="pop_general_title_sub">{{ subTitle }}</div>
    <div class="pop_general">
      <An :number="tval" />
    </div>
    <div
      v-if="prct"
      class="pop_general_arrow"
      :style="{ transform: 'rotate(' + arrow + ')' }"
    >
      →
    </div>
    <div class="pop_general_prct"><An :number="positivePrct" /> %</div>
  </div>
</template>

<script>
import An from "@/components/AnimateNumber.vue";

export default {
  components: { An },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    tval: {
      type: Number,
      required: true,
      default: 0,
    },
    prct: {
      type: Number,
      required: false,
      default: 0,
    },
    arrow: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    positivePrct() {
      return Math.abs(this.prct);
    },
  },
};
</script>

<style scoped>
.pop_general {
  padding: 8px 6px;
  font-size: 2.4em;
  color: darkred;
  position: absolute;
  bottom: 4px;
  left: 12px;
}
.pop_general_prct {
  position: absolute;
  right: 11px;
  bottom: 0px;
  color: #868686;
  font-size: 2em;
}
.pop_general_title {
  font-size: 1.5em;
  height: 28px;
  font-weight: bold;
  color: #018080;
}
.pop_general_title_sub {
  margin-bottom: 0px;
}
.pop_general_arrow {
  position: absolute;
  top: 84px;
  right: 87px;
  font-size: 1.6rem;
  color: gray;
}
.general_frame {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 3px 0 #ccc;
  padding: 8px 12px;
  width: 260px;
  position: relative;
  height: 126px;
}
</style>

